import React, { useState } from "react";
import PropTypes from "prop-types";
import { Stack, Tooltip } from "@mui/material";
import { SwitchContainer, SwitchButton, SwitchText } from "../styles";
import SearchField from "./SearchField";
import { ASSETS } from "../../../../utils/config";
import IyugaTooltip from "../../../IyugaTooltip";
import GridIcon from "../../../../assets/icons/GridIcon";
import ListIcon from "../../../../assets/icons/ListIcon";
import { colors } from "../../../../utils";
import { showCreateWheelPopup } from "../../../../redux/reducers/createWheelPopup";
import { useDispatch } from "react-redux";
import { canCreateWheel } from "../../../../services/api";
// import { WheelLimitPopup } from "../../../WheelLimitPopup";
import {
  openDialogPopup,
  closeDialogPopup,
} from "../../../../redux/reducers/dialogPopup";
import { useNavigate } from "react-router-dom";

const ListHeader = ({
  searchedText,
  onSearchChange,
  onSearchSubmit,
  isGridSelect,
  onViewToggle,
  isUserProfile,
  onCreateNew,
  isSwitchDisabled,
  containerStyles = {},
  tabChild,
}) => {
  // const [openPopup, setOpenPopup] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onCreateNewWheel = async () => {
    try {
      const response = await canCreateWheel();
      console.log("response", response);
      if (response?.data?.status_code === 200) {
        dispatch(showCreateWheelPopup());
      }

      // if(response.status === 403) {
      //   dispatch(openDialogPopup({
      //     isOpen:true,
      //     title:"Upgrade to Create More Wheels!",
      //     primaryButtonTitle:"Upgrade today!",
      //     secondaryButtonTitle:"Cancel",
      //     text: "You've reached your limit of 5 Wheels. Upgrade your plan to unlock unlimited Wheel creation and enjoy all of the additional features!",
      //     secondaryButtonOnClick: ()=>dispatch(closeDialogPopup()),
      //     primaryButtonOnClick: () => {
      //       dispatch(closeDialogPopup())
      //       navigate("/settings?option=subscriptions")
      //     }
      //   }))
      // }
    } catch (err) {
      console.log("error", err);
      if (err.status === 403) {
        dispatch(
          openDialogPopup({
            isOpen: true,
            title: "Upgrade to Create More Wheels!",
            primaryButtonTitle: "Upgrade today!",
            secondaryButtonTitle: "Cancel",
            text: "You've reached your limit of 5 Wheels. Upgrade your plan to unlock unlimited Wheel creation and enjoy all of the additional features!",
            secondaryButtonOnClick: () => dispatch(closeDialogPopup()),
            primaryButtonOnClick: () => {
              dispatch(closeDialogPopup());
              navigate("/settings?option=subscriptions");
            },
          })
        );
      }
    }
  };

  const renderSwitchButton = (isGridView) => {
    return (
      <SwitchButton
        sx={{ pr: 1 }}
        selected={isGridView === isGridSelect}
        onClick={() => onViewToggle(isGridView)}
        disabled={isSwitchDisabled}
      >
        {isGridView ? (
          <GridIcon
            width={14}
            height={14}
            fill={isGridSelect ? colors.white : colors.PrimaryPurple}
          />
        ) : (
          <ListIcon
            width={14}
            height={14}
            fill={!isGridSelect ? colors.white : colors.PrimaryPurple}
          />
        )}
        {isGridView === isGridSelect && (
          <SwitchText sx={{ m: 0, p: 0 }} disabled={isSwitchDisabled}>
            {isGridView ? "Grid" : "List"}
          </SwitchText>
        )}
      </SwitchButton>
    );
  };

  const styles = {
    container: {
      // marginTop: 2,
      marginBottom: 1,
      backgroundColor: colors.white,
      ...containerStyles,
    },
    leftSection: {
      flex: 1,
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
    },
    centerSection: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    rightSection: {
      flex: 1,
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
    },
  };

  return (
    <Stack
      sx={styles.container}
      alignItems="center"
      direction="row"
      justifyContent="space-between"
    >
      <div style={styles.leftSection}>{tabChild()}</div>

      <div style={styles.centerSection}>
        {isUserProfile && (
          <IyugaTooltip tooltip="Create New Wheel">
            <div className="create-wheel-button" style={{ cursor: "pointer" }}>
              <img
                onClick={onCreateNewWheel}
                src={ASSETS.segmentEditor.AddWheelV2}
                height={60}
                width={60}
                alt="Add Wheel"
              />
            </div>
          </IyugaTooltip>
        )}
      </div>

      <div style={styles.rightSection}>
        <SearchField
          fullWidth={false}
          value={searchedText}
          handleChange={onSearchChange}
          handleSearch={onSearchSubmit}
          disabled={isSwitchDisabled}
          sx={{ width: "170px" }}
        />
        <SwitchContainer disabled={isSwitchDisabled}>
          {renderSwitchButton(true)}
          {renderSwitchButton(false)}
        </SwitchContainer>
      </div>

      {/* <WheelLimitPopup
        open={openPopup} 
        handleClose={() => setOpenPopup(false)}
        type="create"
      /> */}
    </Stack>
  );
};

ListHeader.propTypes = {
  searchedText: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onSearchSubmit: PropTypes.func.isRequired,
  isGridSelect: PropTypes.bool.isRequired,
  onViewToggle: PropTypes.func.isRequired,
  isUserProfile: PropTypes.bool.isRequired,
  onCreateNew: PropTypes.func.isRequired,
  isSwitchDisabled: PropTypes.bool,
  containerStyles: PropTypes.object,
};

ListHeader.defaultProps = {
  isSwitchDisabled: false,
  containerStyles: {},
};

export default ListHeader;
